// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  hmr: false,
  isMockEnabled: false, // You have to switch this, when your real back-end is done,
  pusher: {
    key: 'ea154f8c2526f5140e61',
    cluster: 'eu',
    authEndpoint: 'http://localhost:8000/broadcasting/auth',
    forceTLS: false,
  },
  chargebee: {
    site: 'persist-kd-testing-test',
  },
  geocodeapi: {
    apiKey: '01f04d70-22b3-11eb-b257-df9df51a64c4',
  },
};
